// import "core-js/modules/es.string.replace-all";

export enum TranslatorStringIds {
    ChooseYourStateHead = "choose_your_state_label",
    ChooseAStateHead = "choose_a_state_label",
    ChooseYourStateDescription = "choose_your_state_content",
    ChooseAStateDescription = "choose_a_state_content",
    ChooseYourStateSelectorLabel = "state_selector_label",
    ChooseYourStateSelectorPlaceholder = "state_selector_placeholder",
    ChooseYourStateCheckAvailabilityButton = "state_selector_cta_button_label",
    ChooseYourStateJoinWaitlistButton = "state_waitlist_cta_button_label",
    ChooseYourStateJoinWaitlistDescription_Template = "state_unavailable_message",
    ChooseYourStateJoinWaitlistAddedHeader = "added_to_waitlist_message_title",
    ChooseYourStateJoinWaitlistAddedDescription_Template = "added_to_waitlist_message_description",
    TwisterVariationMessagingTitle = "twister_variation_messaging_title",
    TwisterVariationVideoTitle = "twister_variation_video_title",
    ChooseOfferHead = "choose_an_online_clinic_label",
    ChooseOfferDescription = "choose_an_online_clinic_content",
    ChooseOfferBuyBoxButtonLabel = "buy_box_button_text",
    ConditionUnavailableMessage = "condition_unavailable_message",
    StartIntakeFormButtonText = "start_intake_form_button_text",
    OfferBoxButtonText = "buy_box_continue_text"
}

export class StringTranslator {
    public readonly strings: Record<string, string>;

    constructor(t: Record<string, string>) {
        this.strings = t || {};
    }

    resolve(key: string, args?: Record<string, string>) {
        const valueOrTemplate = this.strings[key] || "";
        if (!args) {
            return valueOrTemplate;
        }
        let value = valueOrTemplate;
        Object.keys(args)
            .forEach(tk => {
                value = value.replaceAll(`{${tk}}`, args[tk]);
            });
        return value;
    }

}